<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.division_feature.division') }}
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('addministration.division_feature.search')"
              style="width: 300px;"
              class="kh-font"
            />
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template slot-scope="{ record }">
              <td class="kh-font">{{ record.division_name_kh }}</td>
              <td>{{ record.division_name_en }}</td>
              <td>
                {{
                  $store.getters.limitStringShow(
                    record.division_description,
                    40
                  )
                }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  v-tooltip="$t('addministration.division_feature.edit')"
                  class="text-primary mr-3"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="$t('addministration.division_feature.delete')"
                  class="text-danger"
                  @click.prevent="destroy(record.division_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'division',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      columns: [
        {
          name: this.$t('addministration.division_feature.name_kh'),
          style: 'width: 25%;'
        },
        {
          name: this.$t('addministration.division_feature.name_en'),
          style: 'width: 25%;'
        },
        { name: this.$t('addministration.division_feature.description') },
        {
          name: this.$t('addministration.division_feature.action'),
          style: 'width: 1px; text-align:center'
        }
      ],
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('division', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.division.search
      },
      set(newVal) {
        this.$store.commit('division/SET_SEARCH', newVal)
        this.$store.commit('division/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('division/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.edit_data = data
      this.$router.push(`/divisions/${data.division_id}`)
    },

    async destroy(id) {
      if (
        await this.$confirmModal.danger(
          this.$t('addministration.division_feature.are_you_sure_to_delete')
        )
      ) {
        this.$store
          .dispatch('division/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'division-create') {
      this.$store.commit('division/RESET_STATE')
      this.fetchData()
    }
    next()
  }
}
</script>
